<template>
<div class="general-active-section" :class="validatedSectionClass">
  <!-- first name / last name-->
  <div class="row" v-if="allowName">
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label for="firstName" class="control-label" :class="nameRequired ? 'required' : ''">
              {{computeCaption(fields_en['first_name'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"
                  type="text"
                  data-vv-as="First Name"
                  name="firstName"
                  id="firstName"
                  v-validate="modelValidations.firstName"
                  v-model="model.firstName"
                  placeholder="ex: Mike"
                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
            <small class="text-danger" v-show="firstName.invalid">
              {{getError('firstName', 'First') && computeCaption(getError('firstName', 'First'), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group">
            <label for="lastName" class="control-label" :class="nameRequired ? 'required' : ''">
              {{computeCaption(fields_en['last_name'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"
                  type="text"
                  id="lastName"
                  data-vv-as="Last Name"
                  name="lastName"
                  v-validate="modelValidations.lastName"
                  v-model="model.lastName"
                  placeholder="ex: Andrew"
                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
            <small class="text-danger" v-show="lastName.invalid">
              {{getError('lastName') && computeCaption(getError('lastName'), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>
      <!--code/phone dob-->
      <div class="row">
        <div class="col-md-5 col-md-offset-1" v-if="allowPhone">
          <div class="form-group">
              <label for="phone" class="control-label" :class="phoneRequired ? 'required' : ''">
                {{computeCaption(fields_en['phone'], $store.state.lang.value.toLowerCase())}}
              </label>
              <input class="form-control phone-cleave-format"
                      autocomplete="off"
                      type="tel"
                      data-vv-as="Phone"
                      name="phone"
                      id="phone"
                      v-validate="modelValidations.phone"
                      v-model="model.phone"
                      v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                      placeholder="ex: (954) 000-0000"
                      maxlength="14"
              />
              <small class="text-danger" v-show="errorPhone">
                {{errorPhone && computeCaption(errorPhone, $store.state.lang.value.toLowerCase())}}
              </small>
          </div>
        </div>
        <div class="col-md-5" v-if="allowDob" :class="allowPhone === false && allowCode === true  ? 'col-md-offset-1' : ''">
          <div class="form-group">
            <label for="dob" class="control-label" :class="dobRequired ? 'required' : ''">
              {{computeCaption(fields_en['date_of_birth'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control date-cleave-format"
                  type="text"
                  id="dob"
                  data-vv-as="Date Of Birth"
                  name="dob_pretty"
                  v-model="model.dob_pretty"
                  placeholder="ex: 12/22/1980"
                  v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                  @change="validateDate($event.target.value)"
                  maxlength="10"
            />
            <small class="text-danger" v-if="errorDate">
              {{errorDate && computeCaption(errorDate, $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
        <div class="col-md-5" v-if="allowCode && !allowPhone">
          <div class="form-group">
            <label for="confimationNumber" class="control-label" :class="codeRequired ? 'required' : ''">
              {{computeCaption(fields_en['confirmation_number'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"
                   type="text"
                   id="confimationNumber"
                   data-vv-as="Confirmation Number"
                   name="code"
                   v-validate="modelValidations.code"
                   v-model="model.code"
                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
            <small class="text-danger" v-show="errorCode">
              {{errorCode && computeCaption(errorCode, $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>
      <!--code -->
      <div class="row">
        <div class="col-md-5 col-md-offset-1" v-if="allowPhone && allowCode">
        <div class="form-group">
            <label for="confimationNumber" class="control-label" :class="codeRequired ? 'required' : ''">
              {{computeCaption(fields_en['confirmation_number'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"
                  type="text"
                  id="confimationNumber"
                  data-vv-as="Confirmation Number"
                  name="code"
                  v-validate="modelValidations.code"
                  v-model="model.code"
                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
            <small class="text-danger" v-show="errorCode">
              {{errorCode && computeCaption(errorCode, $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
          </div>
      </div>
</div>
</template>

<script>
  import {mapFields} from 'vee-validate'
  import {FormatterUtils} from '../../../../utils/Formatter'
  import {ValidationUtils} from '../../../../utils/Validation.js'
  import Cleave from 'cleave.js'
  import {TranslationsUtils} from '../../../../utils/Translations'
  require('cleave.js/dist/addons/cleave-phone.us')
  export default {
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils],
    props: {
      allowName: {default: undefined},
      nameRequired: {default: undefined}, // if nameRequired === true, allowName must be true
      allowCode: {default: undefined},
      codeRequired: {default: undefined}, // if codeRequired === true, allowCode must be true
      allowDob: {default: undefined},
      dobRequired: {default: undefined}, // if dobRequired === true, allowDob must be true
      allowPhone: {default: undefined},
      phoneRequired: {default: undefined}
    },
    data () {
      return {
        errorPhone: '',
        errorCode: '',
        errorDate: '',
        model: {
          firstName: '',
          lastName: '',
          dob: '',
          dob_pretty: '',
          code: this.$route.query.confirmation_number,
          phone: ''
        },
        validationObject: {
          firstNameValidation: !(this.nameRequired === true),
          lastNameValidation: !(this.nameRequired === true),
          dobValidation: !(this.dobRequired === true),
          codeValidation: !(this.codeRequired === true),
          phoneValidation: !(this.phoneRequired === true)
        },
        validatedSectionClass: '',
        fields_en: {
          first_name: 'First Name',
          last_name: 'Last Name',
          date_of_birth: 'Date Of Birth',
          confirmation_number: 'Confirmation Number',
          phone: 'Phone'
        },
        modelValidations: {
          firstName: {
            min: 2,
            required: this.nameRequired === true
          },
          lastName: {
            min: 2,
            required: this.nameRequired === true
          },
          dob: {
            required: this.dobRequired === true,
            date_format: 'yyyy-MM-dd',
            regex: '^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\\d\\d$'
          },
          code: {
            required: this.codeRequired === true
          },
          phone: {
            required: this.phoneRequired === true,
            min: 14,
            regex: '^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})(?:\\s*(?:#|x\\.?|ext\\.?|extension)\\s*(\\d+))?$'
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        if (this.modelValidations.firstName.required === true && this.modelValidations.lastName.required === true) {
          await this.$validator.validateAll()
        }
        if (this.$validator.errors.items.length !== 0) {
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        }
        if (this.modelValidations.code.required === true) {
          if (!this.model.code) {
            this.errorCode = 'This field is required'
            document.getElementsByName('code')[0].focus()
          }
        }
        if (this.modelValidations.dob.required === true) {
          if (!this.model.dob) {
            this.errorDate = 'This field is required'
            document.getElementsByName('dob_pretty')[0].focus()
          }
        }
        if (this.modelValidations.phone.required === true) {
          if (!this.model.phone) {
            this.errorPhone = 'This field is required'
            document.getElementsByName('phone')[0].focus()
          }
        }
        if (this.$validator.errors.items.length || this.errorCode !== '' || this.errorDate !== '' || this.errorPhone !== '') {
          return false
        }
        return this.model
      }
    },
    computed: {
      ...mapFields(['firstName', 'lastName'])
    },
    beforeMount () {
      if (Object.values(this.validationObject).every(field => field === true)) {
        this.validatedSectionClass = 'validated-section-class'
      }
      if (this.$store.state.confirmationNumberResultsUrl !== '') {
        this.model.code = this.$store.state.confirmationNumberResultsUrl
      }
    },
    watch: {
      'model.dob_pretty': {
        handler: function (dobValue) {
          if (this.modelValidations.dob.required === true && this.allowDob === true) {
            let dateCleave = new Cleave('.date-cleave-format', {
              date: true,
              delimiter: '/',
              datePattern: ['m', 'd', 'Y']
            })
            this.model.dob_pretty = dateCleave.getFormattedValue()
            if (dobValue.length === 10) {
              let dateParts = dobValue.split('/')
              this.model.dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
              if (!this.isFutureDate(dobValue) && !this.isOldDate(dobValue)) {
                this.validationObject.dobValidation = true
              } else {
                if (!this.isFutureDate(dobValue)) {
                  this.validationObject.dobValidation = false
                }
                if (!this.isOldDate(dobValue)) {
                  this.validationObject.dobValidation = false
                }
              }
            } else {
              this.validationObject.dobValidation = false
            }
          } else {
            this.validationObject.dobValidation = true
          }
        },
        deep: true
      },
      'model.firstName': {
        handler: function (dobValue) {
          if (this.modelValidations.firstName.required === true && this.allowName === true) {
            if (this.model.firstName.length > this.modelValidations.firstName.min - 1) {
              this.validationObject.firstNameValidation = true
            } else {
              this.validationObject.firstNameValidation = false
            }
          } else {
            this.validationObject.firstNameValidation = true
          }
        }
      },
      'model.lastName': {
        handler: function (dobValue) {
          if (this.modelValidations.lastName.required === true && this.allowName === true) {
            if (this.model.lastName.length > this.modelValidations.lastName.min - 1) {
              this.validationObject.lastNameValidation = true
            } else {
              this.validationObject.lastNameValidation = false
            }
          } else {
            this.validationObject.lastNameValidation = true
          }
        }
      },
      'model.code': {
        handler: function (before, after) {
          if (this.modelValidations.code.required === true && this.allowCode === true) {
            if (this.model.code) {
              this.errorCode = ''
              this.validationObject.codeValidation = true
            } else {
              this.errorCode = 'This field is required'
              this.validationObject.codeValidation = false
            }
          } else {
            this.erroCode = ''
            this.validationObject.codeValidation = true
          }
        }
      },
      'model.phone': {
        handler: function (after, before) {
          let phoneCleave = new Cleave('.phone-cleave-format', {
            numericOnly: true,
            delimiters: ['(', ')', ' ', '-'],
            blocks: [0, 3, 0, 3, 4]
          })
          this.model.phone = phoneCleave.getFormattedValue()
          if (this.model.phone.length > this.modelValidations.phone.min - 1) {
            this.validationObject.phoneValidation = true
            this.errorPhone = ''
          } else {
            this.errorPhone = 'This field is required'
            this.validationObject.phoneValidation = false
          }
        },
        deep: true
      },
      'validationObject': {
        handler: function (before, after) {
          if (Object.values(this.validationObject).every(field => field === true)) {
            this.validatedSectionClass = 'validated-section-class'
          } else {
            this.validatedSectionClass = 'invalid-section-class'
          }
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/MinimalIdentityCheck.vue